export default __webpack_public_path__ + "static/media/org_mobile.c23dcb2d.svg";